function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "23",
  height: "23",
  viewBox: "0 0 23 23",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M13.699 23c.873 0 1.466-.679 1.875-1.724l7.146-18.69c.183-.474.28-.894.28-1.25C23 .517 22.483 0 21.663 0c-.355 0-.776.108-1.25.28L1.65 7.47C.701 7.824 0 8.427 0 9.3c0 1.056.776 1.488 1.854 1.8l7.77 2.274 2.253 7.696C12.201 22.19 12.632 23 13.7 23zm-3.363-11.813L4.074 9.28c-.14-.054-.183-.097-.183-.162 0-.075.032-.13.161-.172L15.78 4.44c.96-.377 1.897-.83 2.985-1.325-.819.668-1.81 1.466-2.5 2.155l-5.928 5.917zm3.557 7.944c-.076 0-.119-.065-.162-.205l-1.918-6.251 5.917-5.939c.668-.668 1.52-1.703 2.166-2.522-.496 1.089-.96 2.037-1.337 3.007l-4.494 11.727c-.054.129-.097.183-.172.183z",
  fill: "#12002D"
})));